import React from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

const AboutMenu = (props) => {   
	const { selectedAbout, arrCategories } = props
	const navigate = useNavigate();
	
	const fncNavigate = (curRow) => {
		if (curRow.internal) {
			navigate('/about' +  curRow.link)
		} else {
			window.open(curRow.link,'_blank')
		}
		
	}
	
	return (
		<div className="flex flex-column subMenu">

			{arrCategories.map(cur => {
				
				const rowClassName = classNames('flex justify-content-between subMenuRow', {
					selected: '/' + selectedAbout === cur.link
				})
				
				return (<>
					{(cur.internal == true  &&
						<div className={rowClassName} onClick={(e) => fncNavigate(cur) }>
							<div className="flex align-items-center" >
								<div className="name">{cur.name}</div>
							</div>
							<div className="flex align-items-center openIcon">
								{(cur.internal ? 
									<i className="pi pi-chevron-right" />
								:
									<i className="pi pi-external-link" />
								)}
							</div>
						</div>
					)}</>
				)
			})}
			
			<div className="external-menu">
			
				{arrCategories.map(cur => {
					
					const rowClassNameExternal = classNames('flex justify-content-between subMenuRow', {
						selected: '/' + selectedAbout === cur.link
					})
					
					return (<>
						{(cur.internal == false  &&
							<div className={rowClassNameExternal} onClick={(e) => fncNavigate(cur) }>
								<div className="flex align-items-center" >
									<div className="name">{cur.name}</div>
								</div>
								<div className="flex align-items-center openIcon">
									<i className="pi pi-arrow-up-right" />
								</div>
							</div>
						)}</>
					)
				})}
			</div>
		</div>
		
    );
}

export default AboutMenu;